const STORAGE_PREFIX = "pagetest_share:";

export function getTestRunKey(metrics, desktop, mobile) {
  const groupId =
    desktop?.testGroupId || mobile?.testGroupId || metrics?.testGroupId;
  if (groupId) return `group:${groupId}`;

  const url = metrics?.url || desktop?.url || mobile?.url || "";
  const dTs = desktop?.timestamp || "";
  const mTs = mobile?.timestamp || "";
  const dPerf = desktop?.performanceScore ?? "";
  const mPerf = mobile?.performanceScore ?? "";
  return `fp:${url}|${dTs}|${mTs}|${dPerf}|${mPerf}`;
}

export function getCachedShareUrl(key) {
  if (!key) return null;
  try {
    return sessionStorage.getItem(STORAGE_PREFIX + key);
  } catch {
    return null;
  }
}

export function setCachedShareUrl(key, url) {
  if (!key || !url) return;
  try {
    sessionStorage.setItem(STORAGE_PREFIX + key, url);
  } catch {
    // non-blocking
  }
}

export async function copyShareUrl(url) {
  if (!url) return false;

  try {
    await navigator.clipboard.writeText(url);
    return true;
  } catch {
    try {
      const input = document.createElement("textarea");
      input.value = url;
      input.setAttribute("readonly", "");
      input.style.position = "fixed";
      input.style.left = "-9999px";
      document.body.appendChild(input);
      input.select();
      const copied = document.execCommand("copy");
      document.body.removeChild(input);
      return copied;
    } catch {
      return false;
    }
  }
}
